// Colunas do grid.
export const Columns = [
	{
		headerName: 'address.street',
		field: 'address.street',
		width: 300,
		filter: true
	},
	{
		headerName: 'address.number',
		field: 'address.number',
		width: 150
	},
	{
		headerName: 'address.complement',
		field: 'address.complement'
	},
	{
		headerName: 'address.neighborhood',
		field: 'address.neighborhood'
	},
	{
		headerName: 'address.state',
		field: 'address.state',
		width: 100
	},
	{
		headerName: 'address.referencePoint',
		field: 'address.referencePoint',
		width: 250
	}
]